/* eslint-disable no-useless-escape */
export const APP_NAME = 'DateCheck'


export const API_VERSION = 'v1'
export const ICON_SIZE_1 = 20
export const ICON_SIZE_2 = 25
export const ICON_SIZE_3 = 15

// PATTERN
export const EMAIL_PATTERN = /\S+@\S+\.\S+/
export const PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+={}\[\]:;"'<>,.?\/\\|`~]).{8,16}$/
export const DOMAIN_PATTERN = /^(https?:\/\/)?((([a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,})|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[^\s]*)?\/?$/
export const MONGODB_PATTERN = /^mongodb(?:\+srv)?:\/\/(?:[a-zA-Z0-9._%+-]+(?::[^@]*)?@)?[a-zA-Z0-9.-]+(?::\d{2,5})?(?:\/\w+)?(?:\?.*)?$/
export const URL_PATTERN = /^(https?:\/\/)?([a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,6}(\/.*)?$/
export const PHONE_PATTERN = /^\+?[0-9\s\-()]{7,15}$/
export const YOUTUBE_URL_PATTERN = /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})$/
export const VARIABLE_NAME_PATTERN = /^[a-z_]+$/

export const NUMBER_PATTERN = /^\d+(\.\d+)?$/
export const MAX_SPLASH_SCREEN_DURATION = 5
export const CSS_PATTERN = /^(?:\d{1,4}(?:\.\d+)?)( |px|em|rem|vh|vw|%)?$/i
export const PX_PATTERN = /^\d{1,4}px$/
export const ALLOWED_ICON_FILE_TYPES = ['image/png']
export const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/
export const ASPECT_RATIO_PATTERN = /^\d{1,3}\/\d{1,3}$/
export const INTEGER_PATTERN = /^(?:0*[1-9]\d*)$/

export const CSS_UNITS = [
    { key: ' ', value: 'No Unit' },
    { key: 'px', value: 'px' },
    { key: '%', value: '%' },
    { key: 'em', value: 'em' },
    { key: 'rem', value: 'rem' },
    { key: 'vh', value: 'vh' },
    { key: 'vw', value: 'vw' }
]

export const CASE_OPTION = [
    { key: 'capital', value: 'Capital' },
    { key: 'small', value: 'Small' },
    { key: 'capitalize', value: 'Capitalize' }
]

export const TEXT_CASE_OPTION = [
    { key: 'uppercase', value: 'Upper Case' },
    { key: 'titlecase', value: 'Title Case' }
]

export const IMAGE_ALIGNMENT = [
    { key: 'left', value: 'Left' },
    { key: 'right', value: 'Right' },
    { key: 'center', value: 'Center' }
]

export const FONT_FAMILY = [
    { key: 'arialBlackItalic', value: 'Arial-Black-Italic' },
    { key: 'arialBlack', value: 'Arial-Black' },
    { key: 'arialBoldItalic', value: 'Arial-BoldItalic' },
    { key: 'arialBold', value: 'Arial-Bold' },
    { key: 'arialExtraBold', value: 'Arial-Extra-Bold' },
    { key: 'arialItalic', value: 'Arial-Italic' },
    { key: 'arialLight', value: 'Arial-Light' },
    { key: 'arialNormal', value: 'Arial-normal' },
    { key: 'arialNarrowBold', value: 'ArialNarrow-Bold' },
    { key: 'arialNarrowBoldItalic', value: 'ArialNarrow-BoldItalic' },
    { key: 'arialNarrowItalic', value: 'ArialNarrow-Italic' },
    { key: 'arialNarrow', value: 'ArialNarrow' },
    { key: 'basicCommercialProRoman', value: 'Basic-Commercial-Pro-Roman' },
    { key: 'bebasNeueSemiRounded', value: 'Bebas-Neue-Semi-Rounded' },
    { key: 'bigCityGrotesqueBold', value: 'BigCityGrotesque_bold' },
    { key: 'bigCityGrotesqueMedium', value: 'BigCityGrotesque_medium' },
    { key: 'bigCityGrotesqueNormal', value: 'BigCityGrotesque_normal' }
]

export const CUSTOM_FIELD_TYPES = [
    { value: 'BOOLEAN', label: 'Boolean' },
    { value: 'CHECKBOX', label: 'Checkbox' },
    { value: 'DATE', label: 'Date' },
    { value: 'DATE_TIME', label: 'Date Time' },
    { value: 'DROP_DOWN', label: 'Dropdown' },
    { value: 'EMAIL', label: 'Email' },
    { value: 'IMAGE', label: 'Image' },
    { value: 'NUMBER', label: 'Number' },
    { value: 'RADIO_BUTTON', label: 'Radio' },
    { value: 'TEXT', label: 'Text' },
    { value: 'TEXT_AREA', label: 'Text Area' },
    { value: 'TIME', label: 'Time' },
    { value: 'COLOR', label: 'Color' }
]

export const DATE_FORMAT = [
    { key: 'dd M yyyy H:S', value: 'dd M yyyy HH:MM' },
    { key: 'dd-mm-yyyy', value: 'dd-mm-yyyy' },
    { key: 'mm-dd-yyyy', value: 'mm-dd-yyyy' }
]

export const DATE_POSITION = [
    { key: 'after-title', value: 'After Title' },
    { key: 'bottom-right', value: 'Bottom Right' }
]

export const BOOLEAN = 'BOOLEAN'
export const CHECKBOX = 'CHECKBOX'
export const IMAGE = 'IMAGE'
export const RADIO_BUTTON = 'RADIO_BUTTON'
export const DROP_DOWN = 'DROP_DOWN'
export const TEXT_AREA = 'TEXT_AREA'
export const TEXT = 'TEXT'
export const COLOR = 'COLOR'
export const NUMBER = 'NUMBER'
export const DATE = 'DATE'
export const DATE_TIME = 'DATE_TIME'
export const TIME = 'TIME'

export const STANDARD = 'Standard'
export const LITE = 'Lite'
export const STANDARD_LITE = 'Standard/Lite'
export const CATEGORY = 'Category'

export const CHAR_SETS = {
    uppercaseChars: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    lowercaseChars: 'abcdefghijklmnopqrstuvwxyz',
    numericChars: '1234567890',
    specialChars: '!@#$%^&*_-+'
}

export const initialCustomFieldDefaultValues = {
    is_required: false,
    is_multi_select: false,
    show_help_text_in_form: false,
    show_in_list: false,
    is_active: true,
    is_conditional: false,
    max_image_count: 1
}

export const CMS = 'CMS'
export const RSS = 'RSS'
export const FACEBOOK_RSS = 'FACEBOOK_RSS'

export const KEYBOARD_TYPES = [
    { value: 'TEXT', key: 'text' },
    { value: 'EMAIL', key: 'email' },
    { value: 'NUMBER', key: 'number' }
]

export const CARD = 'CARD'

export const INTERVAL_OPTIONS = [
    // { label: 'Daily', value: 'day' },
    // { label: 'Weekly', value: 'week' },
    { label: 'Monthly', value: 'month' },
    { label: 'Yearly', value: 'year' }
]

export const TYPE_OPTIONS = [
    { label: 'Recurring', value: 'recurring' },
    { label: 'One Time', value: 'one_time' }
]
